<div #container class="map-container"
  leaflet
  [leafletOptions]="options"
  [leafletLayersControl]="leafletLayersControl"
  (leafletMapReady)="onMapReady($event)"
  (leafletClick)="mapClicked($event)"
  (leafletMouseDown)="mapMouseDown($event)"
  (leafletMouseUp)="mapMouseUp($event)">
</div>